<h2 mat-dialog-title class="md-0">
 Add New Products to
  {{ selectedCompany?.companyName || '---' }}
</h2>

<div class="import-product__overlay" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" class="import-product__progress-bar"></mat-progress-bar>
  <span>Loading data...</span>
</div>

<div mat-dialog-content class="import-product">
  <div
    class="import-product__summary"
    *ngIf="!loading && !companyNotFound && rows.length"
  >
    Will add {{ selectedProductCount }}
    {{ selectedProductCount === 1 ? 'new product' : 'new products' }}
    to {{ companyPossessiveName }} tech stack.
    {{ skippedProductCount }}
    {{ skippedProductCount === 1 ? 'product will be' : 'products will be' }}
    skipped as they do not exist in BuyerCaddy yet.
  </div>

  <ng-container *ngIf="!companyNotFound; else companyMissingState">
    <ng-container *ngIf="rows.length; else emptyState">
      <div class="import-product__table-wrapper">
        <table mat-table [dataSource]="rows" class="import-product__table">
          <ng-container matColumnDef="selected">
            <th mat-header-cell *matHeaderCellDef class="import-product__select-column">
            </th>
            <td mat-cell *matCellDef="let row" class="import-product__select-column">
              <mat-checkbox
                color="primary"
                [disabled]="row?.foundCount === 0"
                [checked]="row.isSelected"
                (change)="toggleRowSelection(row, $event.checked)"
              ></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="ProductName">
            <th mat-header-cell *matHeaderCellDef>Product Name</th>
            <td mat-cell *matCellDef="let row">
              <span
                *ngIf="row.foundCount > 0"
                [ngbPopover]="row.product?.name ? 'Selected BC Product: ' + row.product?.name + ', Found ' + row.foundCount : ''"
                triggers="mouseenter:mouseleave"
                container="body"
                role="button"
                (click)="openProductSelectDialog(row)"
              >
                {{ row.ProductName }}
              </span>
              <span
                *ngIf="row.foundCount === 0"
                [ngbPopover]="'Product not found'"
                triggers="mouseenter:mouseleave"
                container="body"
              >
                {{ row.ProductName }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="Country">
            <th mat-header-cell *matHeaderCellDef>Country</th>
            <td mat-cell *matCellDef="let row">
              {{ row.Country }}
            </td>
          </ng-container>

          <ng-container matColumnDef="Industry">
            <th mat-header-cell *matHeaderCellDef>Industry</th>
            <td mat-cell *matCellDef="let row">
              {{ row.Industry }}
            </td>
          </ng-container>

          <ng-container matColumnDef="Probability">
            <th mat-header-cell *matHeaderCellDef>Probability</th>
            <td mat-cell *matCellDef="let row">
              {{ row.Probability }}
            </td>
          </ng-container>

          <ng-container matColumnDef="Source">
            <th mat-header-cell *matHeaderCellDef>Source</th>
            <td mat-cell *matCellDef="let row">
              {{ row.Source }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dateFirstVerified">
            <th mat-header-cell *matHeaderCellDef>First Verified</th>
            <td mat-cell *matCellDef="let row">
              {{ row.dateFirstVerified | date: 'mediumDate' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dateLastVerified">
            <th mat-header-cell *matHeaderCellDef>Last Verified</th>
            <td mat-cell *matCellDef="let row">
              {{ row.dateLastVerified | date: 'mediumDate' }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #emptyState>
    <div class="import-product__empty">
      <p>No product found for this company yet.</p>
    </div>
  </ng-template>
</div>

<ng-template #companyMissingState>
  <div
    class="import-product__empty import-product__empty--not-found"
    *ngIf="!loading"
  >
    <p>Company not found in BuyerCaddy. Please close this dialog to continue.</p>
  </div>
</ng-template>

<mat-dialog-actions align="end" class="import-product__actions">
  <button mat-flat-button  type="button" (click)="onClose()">
    Close
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="importSelected()"
    [disabled]="!canImport"
  >
    <span *ngIf="!importing">Import</span>
    <span *ngIf="importing">Importing...</span>
  </button>
</mat-dialog-actions>
